module.exports = __webpack_public_path__ + "static/media/roxana_cojocaru.f6eeed46.png";